<div nz-row class="display-panel-body-line-style">
  <div nz-col [nzSpan]="24" [nzSm]="9" class="display-panel-line-header">{{propertyName}}:</div>
  <div nz-col [nzSpan]="24" [nzSm]="15" [innerHTML]=propertyValue class="display-panel-line-body" id={{propertyName}} *ngIf="!addressFieldValue"></div>
  <div nz-col [nzSpan]="24" [nzSm]="15" [innerHTML]=propertyValue class="display-panel-line-address" *ngIf="addressFieldValue"></div>
</div>
